import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const TotalStudentDisplay = ({ formik, translationPrefix }) => {
  const { t } = useTranslation();

  const [totalStudentsSelected, setTotalStudentsSelected] = useState({
    thu: 0,
    fri: 0,
  });

  useEffect(() => {
    let tempThu = 0;
    let tempFri = 0;

    formik.values?.classes?.forEach((classDetail) => {
      if (classDetail.visitDay === 'thu') {
        tempThu += parseInt(classDetail.numberOfStudents) || 0;
      } else if (classDetail.visitDay === 'fri') {
        tempFri += parseInt(classDetail.numberOfStudents) || 0;
      }
    });

    setTotalStudentsSelected({
      thu: tempThu,
      fri: tempFri,
    });
  }, [formik.values?.classes]);

  return (
    <div className="w-full mt-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="col-span-1">
          <div
            className="font-semibold text-sm text-gray-10 mb-2"
            dangerouslySetInnerHTML={{ __html: t(`${translationPrefix}.totalStudents.thu`) }}
          />
          <div className="bg-gray-100 p-4 rounded-lg text-center text-gray-10/60">
            {totalStudentsSelected.thu}
          </div>
        </div>

        <div className="col-span-1">
          <div
            className="font-semibold text-sm text-gray-10 mb-2"
            dangerouslySetInnerHTML={{ __html: t(`${translationPrefix}.totalStudents.fri`) }}
          />
          <div className="bg-gray-100 p-4 rounded-lg text-center text-gray-10/60">
            {totalStudentsSelected.fri}
          </div>
        </div>
      </div>

      <div className="mt-6">
        <div
          className="text-base font-bold text-center text-navy-10 mb-2"
          dangerouslySetInnerHTML={{ __html: t(`${translationPrefix}.totalStudents.total`) }}
        />
        <div className="bg-gray-100 p-4 rounded-lg text-center text-gray-10/60 max-w-md mx-auto">
          {totalStudentsSelected.thu + totalStudentsSelected.fri}
        </div>
      </div>

      <div
        className="mt-8 text-center"
        dangerouslySetInnerHTML={{ __html: t(`${translationPrefix}.totalStudents.warning`) }}
      />
    </div>
  );
};

export default TotalStudentDisplay;
